import { FLOATING_TRIGGER_PROPS } from '../Floating/Floating.constants';

import type { SelectOption } from './Select.types';

export const SELECT_ALL_OPTION_KEY = 'select-all-option-key';
export const SELECT_DEFAULT_LIST_HEIGHT = 256;
export const SELECT_TRIGGER_EVENTS = FLOATING_TRIGGER_PROPS;
export const SELECT_DEFAULT_OPTION_LABEL_PROP = 'label' as keyof SelectOption;
export const SELECT_DEFAULT_OPTION_FILTER_PROP = '__searchableLabel' as keyof SelectOption;
export const SELECT_DEFAULT_OPTION_KEY_PROP = 'value' as keyof SelectOption;
